import React, {useEffect, useState} from 'react'
import styled from "styled-components";
import {
    arrayUnion,
    collection,
    doc,
    getFirestore,
    onSnapshot,
    setDoc,
    updateDoc,
    deleteDoc,
    arrayRemove,
    addDoc
} from "firebase/firestore";
import {deleteObject, getStorage, ref} from "firebase/storage"
import {useSelector} from "react-redux";
import PostPhotoModal from "../modals/postPhotoModal";
import LikeInfoModal from "../modals/likeInfoModal";
import ShareModal from "../modals/shareModal";
import {useNavigate} from "react-router-dom";

const LikeIcon = require("../../images/icons/like.png")
const CommentIcon = require("../../images/icons/comment.png")
const ShareIcon = require("../../images/icons/shere.png")
const LikedIcon = require("../../images/icons/liked.png")
const SeeMoreIcon = require("../../images/icons/see-more.png")
const BinIcon = require("../../images/icons/bin.png")

interface PostProp {
    post :any,
    showPostsLength :number
    type :string,
    postId ?:any,
    page :string,
}

const PostBox = styled.div`
    width: 750px;
    border-radius: 10px;
    box-shadow: 1px 4px 10px #00000020;
    margin: 0 auto 30px;

    @media screen and (max-width: 850px) {
        width: 600px;
    }
  
    @media screen and (max-width: 620px) {
        width: 350px;
        margin-bottom: 15px;
    }
`

const PostContentLayer = styled.div`
    margin-left: 85px;
    margin-top: 5px;
    margin-bottom: 7px;
  
    p {
        white-space: pre-wrap;
        word-break: break-all;
        font-size: 20px;
        width: 90%;
        margin: 0;
    }
  
    @media screen and (max-width: 850px) {
        margin-left: 25px;
    }
  
    @media screen and (max-width: 620px) {
        margin-left: 15px;
        p {
            font-size: 15px;
        }
    }
`

const ProfileLayer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    & > div {
        display: flex;
        align-items: center;
    }

    @media screen and (max-width: 620px) {
        img {
            width: 35px;
            height: 35px;
        }
    }
`

const AuthorNameLayer = styled.p`
    font-size: 20px;
    margin: 0;

    @media screen and (max-width: 620px) {
        font-size: 15px;
    }
`

const AuthorIdAndDate = styled.div`
    margin: 0;
    display: flex;
    
    p {
        font-size: 10px;
        color: #7C7C7C;
        margin: 0 10px 0 0;
      
        @media screen and (max-width: 620px) {
            font-size: 7px;
        }
    }
`

const PostCommentLayer = styled.div`
    border-top: 1px solid gray;
    width: 580px;
    margin: 0 auto;
    display: flex;
    
    a {
        display: flex;
        margin: 3px auto;
        color: black;
        text-decoration: none;
        cursor: pointer;
    }
  
    p {
        margin: 5px;
    }
  
    @media screen and (max-width: 850px) {
        width: 550px;
        p {
            display: none;
        }
    }
  
    @media screen and (max-width: 620px) {
        width: 320px;
    }
`

const PostLikeInfoLayer = styled.div`
    width: 580px;
    margin: 0 auto;
    font-size: 13px;
    color: #7C7C7C;
    display: flex;
  
    div {
        width: 10px;
    }
  
    @media screen and (max-width: 850px) {
        width: 550px;
    }
  
    @media screen and (max-width: 620px) {
        font-size: 7px;
        width: 320px;
    }
`

const PostFileLayer = styled.div`
    margin-left: 85px;
  
    img {
        border-radius: 10px;
    }
  
    audio {
       width: 630px;
    }
  
    @media screen and (max-width: 850px) {
        img, video, audio {
            width: 550px;
        }
      
        margin-left: 25px;
    }
  
    @media screen and (max-width: 620px) {
        margin-left: 15px;
      
        img, video, audio {
            width: 320px;
        }
    }
`

const SeeMoreButton = styled.a`
    margin-left: 24px;
    margin-top: 12px;
    margin-right: 12px;
  
    img {
        margin: 0;
    }
`

const MeatballButton = styled.div<{isActived :boolean}>`
    width: 20px;
    height: 20px;
    transform: translateY(-50%);
    cursor: pointer;
    margin-left: 10px;
    margin-top: 17px;
    margin-right: 24px;

    span{
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: black;
        position: absolute;
    }
  
    & span:nth-child(1){
        top: 35%;
        left: 0;
        transition: .3s;
    }

    & span:nth-child(2){
        top: 35%;
        left: 35%;
    }

    & span:nth-child(3){
        top: 35%;
        left: 72%;
        transition: .3s;
    }
  
    ${(props :any) => (props.isActived ? `
        span:nth-child(1){
            transform: translate(1px,-5px);
        }
    
        span:nth-child(3){
            transform: translate(-1px,5px);
        }
    ` : null)}
`

const PostMenuLayer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

const PostMenuBar = styled.div`
    box-shadow: 1px 4px 10px #00000028;
    padding: 5px 10px 5px;
    border-radius: 10px;
    position: absolute;
    background-color: white;
    transform: translate(-120px, 0);

    @media screen and (max-width: 650px) {
        transform: translate(-105px, 0);
    }
`

const PostMenuItem = styled.div`
    display: flex;
    cursor: pointer;  
  
    img {
        margin: 7px 6px 7px 0;
        width: 30px;
    }
    
    p {
        margin: auto 0;
        text-align: left;
        width: 105px;
    }

    @media screen and (max-width: 650px) {
        img {
            width: 25px;
            height: 25px;
        }
      
        p {
            font-size: 13px;
        }
    }
`

const LikeInfoButton = styled.a`
    cursor: pointer;
    
    &:hover {
        text-decoration: underline;
    }
`

const OnlineLight = styled.div`
    width: 15px;
    height: 15px;
    border-radius: 90px;
    background-color: #2FD076;
    position: absolute;
    transform: translate(59px, -15px);

    @media screen and (max-width: 620px) {
        transform: translate(40px, -10px);
        width: 10px;
        height: 10px;
    }
`

const ProfileImage = styled.div<{image :string}>`
    background-image: url(${props => props.image});
    background-size: cover;
    background-position: center;
    width: 50px;
    height: 50px;
    border-radius: 90px;
    margin-left: 24px;
    margin-top: 13px;

    @media screen and (max-width: 620px) {
        width: 35px;
        height: 35px;
        margin-right: 0;
        margin-left: 15px;
    }
`

interface MenuProps {
    showMenu :boolean,
    onDeleteClick ?:() => void
}

function AuthorMenu({showMenu, onDeleteClick} :MenuProps) {
    if (showMenu) {
        return (
            <PostMenuBar>
                <PostMenuItem onClick={onDeleteClick}>
                    <img src={BinIcon} alt="bin icon"/>
                    <p>Delete this post</p>
                </PostMenuItem>
            </PostMenuBar>
        )
    } else {
        return null
    }
}

function UserMenu({showMenu} :MenuProps) {
    if (showMenu) {
        return (
            <PostMenuBar>user menu will be here</PostMenuBar>
        )
    } else {
        return null
    }
}

function Post({post, showPostsLength, type, postId, page} :PostProp) {
    const [authorProfile, setAuthorProfile] = useState<any>()
    const [createdDate, setCreatedDate] = useState<string>("")
    const [likeList, setLikeList] = useState<object[]>([])
    const [isLiked, setIsLiked] = useState<boolean>(false)
    const [photoModalShow, setPhotoModalShow] = useState<boolean>(false)
    const [comments, setComments] = useState<object[]>([])
    const [isMeatballButtonActived, setIsMeatballButtonActived] = useState<boolean>(false)
    const [showAuthorMenu, setShowAuthorMenu] = useState<boolean>(false)
    const [showUserMenu, setShowUserMenu] = useState<boolean>(false)
    const [showLikeInfoModal, setShowLikeInfoModal] = useState<boolean>(false)
    const [isOnline, setIsOnline] = useState<boolean>(false)
    const [showShareModal, setShowShareModal] = useState<boolean>(false)
    const [followings, setFollowings] = useState<string[]>([])
    const [isPrivate, setIsPrivate] = useState<boolean>(false)

    const data = useSelector((state => state))
    // @ts-ignore
    const [userObj] = [data.userObj]
    const postBox = document.getElementById("post-box")
    const navigate = useNavigate()

    useEffect(() => {
        const unsub = onSnapshot(doc(getFirestore(), "users", post.author), (doc :any) => {
            if (doc.exists) {
                setAuthorProfile(doc.data())
            }
        })

        let likeListPath = `posts/${post.id}/likes`

        if (type === "comment") {
            likeListPath = `posts/${postId}/comments/${post.id}/likes`
        }

        const getLikeList = onSnapshot(collection(getFirestore(), likeListPath), (querySnapshot :any) => {
            const likes :any = []
            querySnapshot.forEach((doc :any) => {
                if (doc.exists) {
                    likes.push(doc.data())
                }
            })
            setLikeList(likes)

            if (likes.find((e :any) => e.userId === userObj.userId) !== undefined) {
                setIsLiked(true)
            } else {
                setIsLiked(false)
            }
        })

        const getComments = onSnapshot(collection(getFirestore(), `posts/${post.id}/comments`), (querySnapshot :any) => {
            const comments :any = []
            querySnapshot.forEach((doc :any) => {
                if (doc.exists) {
                    comments.push({
                        ...doc.data(),
                        id: doc.id
                    })
                }
            })
            setComments(comments.sort((a :any, b :any) => parseFloat(b.createdAt.seconds) - parseFloat(a.createdAt.seconds)))
        })

        const getFollowings = onSnapshot(collection(getFirestore(), `users/${post.author}/followings`), (querySnapshot) => {
            const followingArray :string[] = []
            querySnapshot.forEach((doc) => {
                if (doc.exists()) {
                    followingArray.push(doc.data().userId)
                }
            })
            setFollowings(followingArray)
        })

        if (post.createdAt !== undefined) {
            const birthdayDate = new Date(post.createdAt.seconds * 1000)
            let monthArr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
            setCreatedDate(monthArr[birthdayDate.getMonth()] + ", " + birthdayDate.getDate().toString() + ", " + birthdayDate.getFullYear().toString())
        }

        if (postBox !== null && page === "post") {
            postBox.innerHTML = postBox.innerHTML.replace(/#[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9_]*/g,
                "<span style='color: #00d2ff'>$&</span>"
            )
        }

        const getOnlineStatus = onSnapshot(doc(getFirestore(), "status", post.author), (doc :any) => {
            if (doc.exists() && doc.data().state === "online") {
                setIsOnline(true)
            } else {
                setIsOnline(false)
            }
        })

        return () => {
            unsub()
            getLikeList()
            getComments()
            getOnlineStatus()
            getFollowings()
        }
    }, [showPostsLength, userObj])

    useEffect(() => {
        if (authorProfile !== undefined && userObj.userId !== undefined) {
            if (authorProfile.private && authorProfile.userId !== userObj.userId) {
                if (followings.find((e :string) => e === userObj.userId) !== undefined) {
                    setIsPrivate(false)
                } else {
                    setIsPrivate(true)
                }
            } else {
                setIsPrivate(false)
            }
        }
    }, [authorProfile, followings, userObj])

    async function onLikeClick() {
        if (!isLiked) {
            if (type !== "comment") {
                if (post.author !== userObj.userId) {
                    await addDoc(collection(getFirestore(), `users/${post.author}/notifications`), {
                        content: `${userObj.name} liked your post`,
                        date: new Date(),
                        isChecked: false,
                        redirection: `/post/${post.id}`,
                        from: userObj.userId
                    })
                }
                await setDoc(doc(getFirestore(), `posts/${post.id}/likes`, userObj.userId), {
                    userId: userObj.userId,
                    likedAt: new Date()
                })

                try {
                    await updateDoc(doc(getFirestore(), "liked", userObj.userId), {
                        postLiked: arrayUnion(post.id)
                    })
                } catch (e) {
                    await setDoc(doc(getFirestore(), "liked", userObj.userId), {
                        postLiked: [post.id]
                    })
                }
            } else {
                if (post.author !== userObj.userId) {
                    await addDoc(collection(getFirestore(), `users/${post.author}/notifications`), {
                        content: `${userObj.name} liked your commit`,
                        date: new Date(),
                        isChecked: false,
                        redirection: `/post/${postId}`,
                        from: userObj.userId
                    })
                }
                await setDoc(doc(getFirestore(), `posts/${postId}/comments/${post.id}/likes`, userObj.userId), {
                    userId: userObj.userId,
                    likedAt: new Date()
                })
            }
        }
    }

    async function onUnLikeClick() {
        if (type !== "comment") {
            await deleteDoc(doc(getFirestore(), `posts/${post.id}/likes`, userObj.userId))
            await updateDoc(doc(getFirestore(), "liked", userObj.userId), {
                postLiked: arrayRemove(post.id)
            })
        } else {
            await deleteDoc(doc(getFirestore(), `posts/${postId}/comments/${post.id}/likes`, userObj.userId))
        }
    }

    function onPhotoClick() {
        setPhotoModalShow(true)
    }

    function onMeatballButtonClick() {
        if (post.author === userObj.userId) {
            if (isMeatballButtonActived) {
                setIsMeatballButtonActived(false)
                setShowAuthorMenu(false)
            } else {
                setIsMeatballButtonActived(true)
                setShowAuthorMenu(true)
            }
        } else {
            if (isMeatballButtonActived) {
                setIsMeatballButtonActived(false)
                setShowUserMenu(false)
            } else {
                setIsMeatballButtonActived(true)
                setShowUserMenu(true)
            }
        }
    }

    async function onDeleteClick() {
        const ok = window.confirm("Are you sure want to delete this post?")
        if (ok) {
            if (post.type === "file") {
                deleteObject(ref(getStorage(), post.file)).then(r => r)
            }

            likeList.map(async (e: any) => {
                await deleteDoc(doc(getFirestore(), "posts", `${post.id}/likes/${e.userId}`))
            })

            if (type !== "comment") {
                comments.map(async (e: any) => {
                    if (e.type === "file") {
                        deleteObject(ref(getStorage(), e.file)).then(r => r)
                    }
                    await deleteDoc(doc(getFirestore(), "posts", `${post.id}/comments/${e.id}`))
                })

                await deleteDoc(doc(getFirestore(), "posts", post.id))
                window.location.href = window.location.origin
            } else {
                likeList.map(async (e: any) => {
                    await deleteDoc(doc(getFirestore(), "posts", `${postId}/comments/${post.id}/likes/${e.id}`))
                })

                await deleteDoc(doc(getFirestore(), "posts", `${postId}/comments/${post.id}`))
            }
        }
    }

    function onLikeInfoClick() {
        setShowLikeInfoModal(true)
    }

    function onShareClick() {
        setShowShareModal(true)
    }

    function onProfileClick() {
        navigate(`/profile/${authorProfile.id}`, {state: {authorProfile, followings}})
    }

    function onSeeMoreClick() {
        navigate(`/post/${post.id}`, {state: {post, userObj, comments}})
    }

    if (authorProfile !== undefined && !isPrivate) {
        return (
            <PostBox>
                <PostPhotoModal
                    photoModalShow={photoModalShow}
                    setPhotoModalShow={setPhotoModalShow}
                    post={post}
                    authorProfile={authorProfile}
                    createdDate={createdDate} isLiked={isLiked}
                    onLikeClick={onLikeClick}
                    onUnLikeClick={onUnLikeClick}
                    likeList={likeList}
                    comments={comments}/>
                <LikeInfoModal showLikeInfoModal={showLikeInfoModal} setShowLikeInfoModal={setShowLikeInfoModal} likeList={likeList}/>
                <ShareModal showShareModal={showShareModal} setShowShareModal={setShowShareModal} post={post}/>
                <ProfileLayer>
                    <div>
                        <a onClick={onProfileClick}>
                            <ProfileImage image={authorProfile.profilePhoto}/>
                            {isOnline ? (
                                <OnlineLight></OnlineLight>
                            ) : null}
                        </a>
                        <div style={{margin: "11px", marginBottom: "0", display: "block"}}>
                            <AuthorNameLayer>{authorProfile.name}</AuthorNameLayer>
                            <AuthorIdAndDate>
                                <p>{"@" + authorProfile.id}</p>
                                <p>{createdDate}</p>
                            </AuthorIdAndDate>
                        </div>
                    </div>
                    {type === "comment" || page === "post" ? (
                        <PostMenuLayer>
                            <AuthorMenu showMenu={showAuthorMenu} onDeleteClick={onDeleteClick}/>
                            <UserMenu showMenu={showUserMenu}/>
                            <MeatballButton isActived={isMeatballButtonActived} onClick={onMeatballButtonClick}>
                                <span></span>
                                <span></span>
                                <span></span>
                            </MeatballButton>
                        </PostMenuLayer>
                    ) : (
                        <SeeMoreButton onClick={onSeeMoreClick}>
                            <img src={SeeMoreIcon} alt="see more icon" width={"50px"}/>
                        </SeeMoreButton>
                    )}
                </ProfileLayer>
                <PostContentLayer>
                    <p id={"post-box"}>{post.content}</p>
                </PostContentLayer>
                <PostFileLayer>
                    {post.type === "gif" ? (
                        <img src={post.file} alt="post file content" width={"630px"}/>
                    ) : post.type === "file" ? (
                        <div>
                            {post.fileType === "image" ? (
                                <img src={post.file} alt="post file content" width={"630px"} style={{cursor: "pointer"}} onClick={onPhotoClick}/>
                            ) : post.fileType === "video" ? (
                                <video controls src={post.file} width={"630px"} style={{borderRadius: "10px"}}/>
                            ) : post.fileType === "audio" ? (
                                <audio controls src={post.file}/>
                            ) : (
                                <p>error</p>
                            )}
                        </div>
                    ) : null}
                </PostFileLayer>
                <PostLikeInfoLayer>
                    {likeList.length !== 0 ? (
                        <LikeInfoButton onClick={onLikeInfoClick}>
                            {likeList.length + " likes"}
                        </LikeInfoButton>
                    ) : null}
                    {likeList.length !== 0 ? (
                        <div></div>
                    ) : null}
                    {comments.length !== 0 ? (
                        comments.length + " comments"
                    ) : null}
                </PostLikeInfoLayer>
                <PostCommentLayer>
                    {isLiked ? (
                        <a onClick={onUnLikeClick}>
                            <img src={LikedIcon} alt="like icon" width={"30px"}/>
                            <p>Liked</p>
                        </a>
                    ) : (
                        <a onClick={onLikeClick}>
                            <img src={LikeIcon} alt="like icon" width={"30px"}/>
                            <p>Like</p>
                        </a>
                    )}
                    {type === "comment" ? null : (
                        <a onClick={onSeeMoreClick}>
                            <img src={CommentIcon} alt="comment icon" width={"30px"}/>
                            <p>Comment</p>
                        </a>
                    )}

                    {type === "comment" ? null : (
                        <a onClick={onShareClick}>
                            <img src={ShareIcon} alt="share icon" width={"30px"}/>
                            <p>Share</p>
                        </a>
                    )}
                </PostCommentLayer>
            </PostBox>
        )
    } else {
        return null
    }
}

export default Post